import { useEffect, useState } from 'react'
import { useAuth } from "../../../../../hooks/AuthContext";
import { PedidoConcluidoPagamentoEscolhido, MenuDashboard, PaginasMenuDashboard, LoadingPedidoRealizadoPagamentoEscolhido } from '../../../../../components'
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { GetPedidoByID } from '../../../../../api/PedidoComercial';
import useAlert from "../../../../../hooks/useAlert";
import { PEDIDOCONCLUIDOPAGAMENTOESCOLHIDO } from '../../../../../util/typesReactQuery'
import useSeoConfig from '../../../../../hooks/useSeoConfig';



export default function ConfirmacaoRecebimento() {
  const { user } = useAuth();
  const { showAlertError } = useAlert();
  const { idPedido } = useParams()
  const [errorMessage, setErrorMessage] = useState("")
  const { sendPageAtual } = useSeoConfig();

  useEffect(() => {
    sendPageAtual("Pedido_efetuado_recebimento")
  }, []);

  const { data: Pedido } = useQuery([`${PEDIDOCONCLUIDOPAGAMENTOESCOLHIDO}${idPedido}`], () => GetPedidoByID(user.id, idPedido), {
    onSuccess: (data) => {
      if (!data || !data?.data) {
        showAlertError(
          "Ops, ocorreu um erro, informe ao suporte tecnico o seguinte erro: Nenhum pedido foi encontrado - R2040 "
        );
        return;
      }

      if (data.errorMessage) {
        showAlertError(
          `Ops, ocorreu um erro, informe ao suporte tecnico o seguinte erro: ${data.errorMessage} - R3256 `
        );
        return;
      }

    },
    onError: (error) => {
      showAlertError(
        `Ops, ocorreu um erro, informe ao suporte tecnico: ${error?.message} -  R98CC`
      );
    },
    refetchOnWindowFocus: false,
  })



  return (
    <>

      <MenuDashboard pagina={PaginasMenuDashboard.Remessas}>
        {!!Pedido?.data ?
          <PedidoConcluidoPagamentoEscolhido pedido={Pedido.data} setErrorMessage={setErrorMessage} />
          :
          <LoadingPedidoRealizadoPagamentoEscolhido />
        }
      </MenuDashboard>
    </>
  );
}
